export default __webpack_public_path__ + "static/media/filter_analyst_blue.f70d7189.svg";